<template>
  <div>
    <Card shadow>
      <Row :gutter="18">
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 60px">代理组:</span>
            <Select
              v-model="table.params.plat_ids"
              filterable
              placeholder="筛选服务器分组"
              :max-tag-count="3"
              clearable
              multiple
              @on-change="clearAppIdCheck"
            >
              <Option
                v-for="(item, index) in plat_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 60px">代理:</span>
            <Select
              v-model="table.params.app_ids"
              filterable
              placeholder="筛选APP盘口"
              :max-tag-count="3"
              clearable
              multiple
              :disabled="table.params.plat_ids.length == 0"
            >
              <Option
                v-for="(item, index) in app_list.filter((el) =>
                  table.params.plat_ids.includes(el.platform)
                )"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">支付平台:</span>
            <Select
              v-model="table.params.pay_id"
              filterable
              placeholder="筛选通道所属支付平台"
              clearable
            >
              <Option
                v-for="(item, index) in select.pay_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">支付类型:</span>
            <Select
              v-model="table.params.pay_type"
              filterable
              clearable
              placeholder="下拉筛选支付类型"
            >
              <Option
                v-for="(item, index) in select.pay_type_list"
                :value="index"
                :label="item"
                :key="index"
                >{{ item }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">通道类型:</span>
            <Select
              v-model="table.params.channel_type"
              filterable
              placeholder="下拉筛选通道类型"
              clearable
            >
              <Option
                v-for="(item, index) in select.channel_type_list"
                :value="index"
                :label="item"
                :key="index"
                >{{ item }}</Option
              >
            </Select>
          </label>
        </Col>
      </Row>
      <Row :gutter="18" style="margin-top: 12px">
        <Col span="7">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">筛选时间:</span>
            <DatePicker
              style="width: 40%"
              type="date"
              format="yyyy-MM-dd"
              v-model="select.dataTime1"
              placeholder="选择日期"
              :options="dateOptions"
              :clearable="false"
            ></DatePicker>
            <TimePicker
              style="width: 60%"
              type="timerange"
              confirm
              :value="select.dataTime2"
              placeholder="选择时间范围"
              :clearable="false"
            ></TimePicker>
          </label>
        </Col>
        <Col span="1">
          <Button type="primary" @click.native="PayOrderInfo()">查询</Button>
        </Col>
      </Row>
    </Card>
    <Table
      border
      :columns="modalTotal.columns"
      :data="modalTotal.data"
      style="margin-top: 12px"
    ></Table>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 12px"
    ></Table>
    <Page
      v-show="table.data.length"
      show-sizer
      show-total
      style="margin-top: 10px"
      :total="table.total"
      :current="table.params.page"
      :page-size-opts="table.pageSizes"
      :page-size="table.params.limit"
      @on-page-size-change="limitchange"
      @on-change="pagechange"
    ></Page>
    <Modal v-model="Channel_Modal.show" width="800">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>盘口支付通道详情</span>
      </p>
      <div>
        <Table
          border
          :columns="Channel_Modal.columns"
          :data="Channel_Modal.data"
          style="margin-top: 12px"
          :height="500"
        ></Table>
      </div>
      <div slot="footer">
        <Button type="warning" @click.native="updateChannelModal(false)"
          >取消</Button
        >
        <Button type="success" @click.native="updateChannelData()"
          >确认修改</Button
        >
      </div>
    </Modal>
    <Modal v-model="Channel_Modal.imageShow" width="950">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>{{ Channel_Modal.imageName }}</span>
      </p>
      <div>
        <ve-histogram
          :data="eCharts.chartData"
          :extend="eCharts.extend"
          :settings="eCharts.chartSettings"
          :ref="eCharts.ref"
          width="900px"
          height="500px"
          :tooltip-visible="false"
        ></ve-histogram>
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  GetAllPayPlatform,
  PayOrderInfo,
  PayOrderTrend,
} from "@/api/admin/newpayment";
import { GetToken } from "../../libs/util";
import moment from "moment";
export default {
  name: "PayChannelData",
  data() {
    return {
      SysConstType: {},
      eCharts: {
        ref: "echartsRef",
        params: {
          date: "", // 日期
          plat_id: 0, // 盘口分组id
          app_id: 0, // 盘口id
          pay_id: 0, // 支付平台id
          pay_type: "", // 支付类型
          channel_pay_type: "", // 通道码
        },
        extend: {
          legend: {
            bottom: -5,
          },
        },
        chartSettings: {
          labelMap: {
            total_order: "提交订单数",
            total_money: "提交订单金额",
            succ_order: "成功订单数",
            succ_money: "成功订单金额",
            order_rate: "订单成功率",
            money_rate: "金额成功率",
          },
          showLine: ["order_rate", "money_rate"],
          axisSite: { right: ["order_rate", "money_rate"] },
          // yAxisType: 'normal',
          yAxisType: ["normal", "percent"],
          //   scale: [true, true]
        },
        chartData: {
          columns: [
            "hour",
            "total_order",
            "total_money",
            "succ_order",
            "succ_money",
            "order_rate",
            "money_rate",
          ],
          rows: [],
        },
      },
      select: {
        pay_list: [], //支付平台列表
        channel_type_list: {}, //通道类型列表
        pay_type_list: {}, //支付类型列表
        dataTime1: this.getCurrentZeroDay(),
        dataTime2: ["00:00:00", "23:59:59"],
      },
      table: {
        params: {
          plat_ids: [], // 盘口分组id
          app_ids: [], // 盘口id
          pay_id: 0, // 支付平台id
          pay_type: "", // 支付类型
          channel_type: "", // 通道类型
          sort: "-succ_money", // 排序
          time: 0,
          end_time: 0,
          page: 1,
          limit: 10,
        },
        data: [],
        columns: [
          {
            type: "index",
            title: "序号",
            minWidth: 50,
            align: "center",
            // renderHeader: (h, params) => (this).renderHeader(h, "ID", "ID")
          },
          {
            key: "app_name",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(h, "所属APP", "显示该支付通道所属的APP"),
          },
          {
            key: "channel_name",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(h, "支付通道名称", "显示支付通道的名称"),
          },
          {
            key: "pay_name",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(h, "支付平台", "显示支付通道所属的支付平台"),
          },
          {
            key: "pay_type",
            align: "center",
            minWidth: 90,
            render: (h, params) => {
              return h(
                "span",
                this.select.pay_type_list[params.row.pay_type] || ""
              );
            },
            renderHeader: (h, params) =>
              this.renderHeader(h, "支付类型", "显示支付通道的支付类型"),
          },
          {
            key: "channel_type",
            align: "center",
            minWidth: 90,
            render: (h, params) => {
              return h(
                "span",
                this.select.channel_type_list[params.row.channel_type] || ""
              );
            },
            renderHeader: (h, params) =>
              this.renderHeader(h, "通道类型", "显示支付通道的通道类型"),
          },
          {
            key: "total_order",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "提交订单数",
                "示支付通道筛选时间内提交的订单数量；所有盘口数据"
              ),
          },
          {
            key: "total_money",
            align: "center",
            minWidth: 90,
            render: (h, params) =>
              h("span", this.getCustomFixed(params.row.total_money / 10000)),
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "提交订单金额",
                "显示支付通道筛选时间内提交的订单金额；所有盘口数据"
              ),
          },
          {
            key: "succ_order",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "成功订单数",
                "显示支付通道筛选时间内成功完成的订单数量；所有盘口数据"
              ),
          },
          {
            key: "succ_money",
            align: "center",
            minWidth: 90,
            render: (h, params) =>
              h("span", this.getCustomFixed(params.row.succ_money / 10000)),
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "成功订单金额",
                "显示支付通道筛选时间内成功完成的订单金额；所有盘口数据"
              ),
          },
          {
            key: "order_rate",
            align: "center",
            minWidth: 90,
            render: (h, params) =>
              h("span", this.getRate(params.row.order_rate / 100)),
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "订单成功率",
                "显示支付通道筛选时间内成功完成的订单数量/提交订单数量；所有盘口数据"
              ),
          },
          {
            key: "money_rate",
            align: "center",
            minWidth: 90,
            render: (h, params) =>
              h("span", this.getRate(params.row.money_rate / 100)),
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "金额成功率",
                "显示支付通道筛选时间内成功完成的订单金额/提交订单金额；所有盘口数据"
              ),
          },

          {
            key: "",
            align: "center",
            minWidth: 120,
            fixed: "right",
            render: (h, params) =>
              this.getButton(h, "趋势图", () => {
                let date = moment(`${params.row.date}`).format("YYYY-MM-DD");
                this.updateChannelModalImage(
                  true,
                  `${params.row.app_name}: ${date}`
                );
                this.updateChartData(params.row);
              }),

            renderHeader: (h, params) =>
              this.renderHeader(h, "管理", "管理【盘口详情】【趋势图】按钮"),
          },
        ],
        total: 0,
        pageSizes: [10, 20, 30, 40],
      },
      Channel_Modal: {
        imageShow: false, //趋势图
        imageName: "",
        show: false, //盘口详情
        data: [], //盘口详情数据
        imageData: {
          data: [],
        },
        ref: "pay_channle_data_modal",
        columns: [
          {
            key: "app_name",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(h, "支付通道ID", "显示支付通道的ID"),
          },
          {
            key: "channel_name",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(h, "支付通道名称", "显示支付通道的名称"),
          },
          {
            key: "pay_name",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(h, "支付平台", "显示支付通道所属的支付平台"),
          },
          {
            key: "pay_type",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(h, "支付类型", "显示支付通道的支付类型"),
            render: (h, params) =>
              h("span", this.select.pay_type_list[params.row.pay_type] || ""),
          },
          {
            key: "channel_type",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(h, "通道类型", "显示支付通道的通道类型"),
            render: (h, params) =>
              h(
                "span",
                this.select.channel_type_list[params.row.channel_type] || ""
              ),
          },
          {
            key: "total_order",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "提交订单数",
                "示支付通道筛选时间内提交的订单数量；所有盘口数据"
              ),
          },
          {
            key: "total_money",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "提交订单金额",
                "显示支付通道筛选时间内提交的订单金额；所有盘口数据"
              ),
            render: (h, params) =>
              h("span", this.getCustomFixed(params.row.total_money / 10000)),
          },
          {
            key: "succ_order",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "成功订单数",
                "显示支付通道筛选时间内成功完成的订单数量；所有盘口数据"
              ),
          },
          {
            key: "succ_money",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "成功订单金额",
                "显示支付通道筛选时间内成功完成的订单金额；所有盘口数据"
              ),
            render: (h, params) =>
              h("span", this.getCustomFixed(params.row.succ_money / 10000)),
          },
          {
            key: "order_rate",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "订单成功率",
                "显示支付通道筛选时间内成功完成的订单数量/提交订单数量；所有盘口数据"
              ),
            render: (h, params) =>
              h("span", this.getRate(params.row.order_rate / 100)),
          },
          {
            key: "money_rate",
            align: "center",
            minWidth: 90,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "金额成功率",
                "显示支付通道筛选时间内成功完成的订单金额/提交订单金额；所有盘口数据"
              ),
            render: (h, params) =>
              h("span", this.getRate(params.row.money_rate / 100)),
          },
          {
            key: "",
            align: "center",
            minWidth: 210,
            fixed: "right",
            renderHeader: (h, params) =>
              this.renderHeader(h, "管理", "管理【盘口详情】【趋势图】按钮"),
            render: (h, params) =>
              h("div", [
                this.getButton(h, "盘口详情", () => {
                  this.updateChannelModal(true);
                }),
                this.getButton(h, "趋势图", () => {
                  this.updateChannelModalImage(true);
                  this.updateChartData(params.row);
                }),
              ]),
          },
        ],
      },
      modalTotal: {
        show: false,
        data: [],
        columns: [
          {
            title: "提交订单数",
            key: "total_order",
            align: "center",
            minWidth: 90,
          },
          {
            title: "提交订单金额",
            key: "total_money",
            align: "center",
            minWidth: 90,
            render: (h, params) =>
              h("span", (params.row.total_money / 10000).toFixed(2)),
          },
          {
            title: "成功订单数",
            key: "succ_order",
            align: "center",
            minWidth: 90,
          },
          {
            title: "成功订单金额",
            key: "succ_money",
            align: "center",
            minWidth: 90,
            render: (h, params) =>
              h("span", (params.row.succ_money / 10000).toFixed(2)),
          },
          {
            title: "订单成功率",
            key: "order_rate",
            align: "center",
            minWidth: 90,
            render: (h, params) =>
              h("span", this.getRate(params.row.order_rate / 100)),
          },
          {
            title: "金额成功率",
            key: "money_rate",
            align: "center",
            minWidth: 90,
            render: (h, params) =>
              h("span", this.getRate(params.row.money_rate / 100)),
          },
        ],
      },
    };
  },
  methods: {
    getButton(h, title, click) {
      return h(
        "Button",
        {
          props: { type: "primary" },
          style: { margin: "2px", padding: "5px 20px" },
          on: { click },
        },
        title
      );
    },
    //列表分页
    pagechange(page) {
      this.table.params.page = page;
      this.PayOrderInfo();
    },
    //列表分条
    limitchange(limit) {
      this.table.params.page = 1;
      this.table.params.limit = limit;
      this.PayOrderInfo();
    },
    updateChannelModal(value) {
      this.Channel_Modal.show = value;
    },
    //保存修改
    updateChannelData() {
      this.updateChannelModal(false);
    },
    updateChannelModalImage(value, name = "") {
      this.Channel_Modal.imageShow = value;
      this.Channel_Modal.imageName = name;
    },
    updateChartData(param) {
      this.eCharts.params.date = param.date;
      this.eCharts.params.plat_id = param.plat_id;
      this.eCharts.params.app_id = param.app_id;
      this.eCharts.params.pay_id = param.pay_id;
      this.eCharts.params.pay_type = param.pay_type;
      this.eCharts.params.channel_pay_type = param.channel_pay_type;
      PayOrderTrend(this.eCharts.params).then((res) => {
        let arr = res._param || [];
        arr.forEach((el, index) => {
          el.hour = index;
          el.succ_money = this.getCustomFixed(el.succ_money / 10000);
          el.total_money = this.getCustomFixed(el.total_money / 10000);
          el.order_rate = el.total_order ? el.succ_order / el.total_order : 0;
          el.money_rate = el.total_money ? el.succ_money / el.total_money : 0;
        });
        this.eCharts.chartData.rows = arr;
        this.$refs[this.eCharts.ref].echarts.resize();
      });
    },
    //获取所有支付平台列表
    GetAllPayPlatform() {
      GetAllPayPlatform({}).then((res) => {
        this.select.pay_list = res._param || [];
      });
    },
    clearAppIdCheck() {
      this.table.params.app_ids = [];
    },
    //系统常量
    getSysConst() {
      this.SysConstType = GetToken().SysConstType;
      //支付类型列表
      this.select.pay_type_list = this.SysConstType.pay_type;

      //通道类型列表
      this.select.channel_type_list = this.SysConstType.channel_type;
    },
    PayOrderInfo() {
      let params = { ...this.table.params };
      params.time = this.getSecondResult(
        moment(this.select.dataTime1).format("YYYY-MM-DD") +
          ` ${this.select.dataTime2[0]}`
      );
      params.end_time = this.getSecondResult(
        moment(this.select.dataTime1).format("YYYY-MM-DD") +
          ` ${this.select.dataTime2[1]}`
      );
      PayOrderInfo(params).then((res) => {
        this.modalTotal.data = [];
        this.table.data = res._param.list || [];
        this.table.total = res._param.total;
        let {
          total_order,
          total_money,
          succ_order,
          succ_money,
          order_rate,
          money_rate,
        } = res._param;
        let obj = {
          total_order,
          total_money,
          succ_order,
          succ_money,
          order_rate,
          money_rate,
        };
        this.modalTotal.data.push(obj);
      });
    },
  },

  created() {
    this.GetAllPayPlatform();
    this.getSysConst();
    this.PayOrderInfo();
    let data = [{}];
    this.table.data = data;
  },
};
</script>
<style lang="less" scoped>
.btn_batch {
  margin-right: 12px;
}
</style>
